<template>
  <div>
    <!-- 碳盘查介绍弹出框 -->
    <CarbonInventoryDialog 
      :visible="carbonInventoryVisible" 
      @close="closeCarbonInventory"
    />
    
    <!-- 碳足迹介绍弹出框 -->
    <CarbonFootprintDialog 
      :visible="carbonFootprintVisible" 
      @close="closeCarbonFootprint"
    />
  </div>
</template>

<script>
import CarbonInventoryDialog from './TpcDialog.vue'
import CarbonFootprintDialog from './TzjDialog.vue'

export default {
  name: 'DialogManager',
  components: {
    CarbonInventoryDialog,
    CarbonFootprintDialog
  },
  data() {
    return {
      carbonInventoryVisible: false,
      carbonFootprintVisible: false
    }
  },
  methods: {
    // 显示碳盘查介绍
    showCarbonInventory() {
      this.carbonInventoryVisible = true;
    },
    
    // 关闭碳盘查介绍
    closeCarbonInventory() {
      this.carbonInventoryVisible = false;
    },
    
    // 显示碳足迹介绍
    showCarbonFootprint() {
      this.carbonFootprintVisible = true;
    },
    
    // 关闭碳足迹介绍
    closeCarbonFootprint() {
      this.carbonFootprintVisible = false;
    },
    
    // 根据产品类型显示对应的介绍
    showProductIntroduction(productType) {
      switch (productType) {
        case 'tpc':
          this.showCarbonInventory();
          break;
        case 'tzj':
          this.showCarbonFootprint();
          break;
        default:
          console.warn('未知的产品类型:', productType);
      }
    }
  }
}
</script>

<style scoped>
/* 组件样式为空，因为所有样式都在子组件中 */
</style> 